import { gsap } from "gsap";
import Isotope from "isotope-layout";
import Chocolat from "chocolat";
import { CustomEase } from "gsap/CustomEase";
gsap.registerPlugin(CustomEase);

const flowersLeft = document.querySelector('#flowers-left');
const flowersRight = document.querySelector('#flowers-right');
const galleryDiv = document.querySelector('.gallery-index__images');

if(document.body.classList.contains('post-type-archive-gallery')){

	window.addEventListener('load', function () {

		flowersLeft.style.visibility = 'visible';
		flowersRight.style.visibility = 'visible';

		gsap.to(galleryDiv, {
	    opacity:1,
	    duration:1,
	    ease: "power1.out"
	  });

		// FLOWER - LEFT

		gsap.fromTo('#flowers-left',
			{
				xPercent:-45,
				rotation:20,
			},
			{
				xPercent:0,
				rotation:0,
				duration:3.5,
				ease: CustomEase.create("custom", "M0,0 C0.7,0 0.2,1 1,1 ")
			}
		);

		// FLOWER - RIGHT

		gsap.fromTo('#flowers-right',
			{
				xPercent:65,
				rotation:-20,
			},
			{
				xPercent:0,
				rotation:0,
				duration:3.5,
				ease: CustomEase.create("custom", "M0,0 C0.7,0 0.2,1 1,1 ")
			}
		);

		// GALLERY

		Chocolat(document.querySelectorAll('.gallery-item a', {
			imageSize: 'cover'
		}))

		const filterButtons = document.querySelectorAll('.gallery-index__filters button');
		let filters = {};

		// INIT

		const filterGallery = new Isotope( '.filter-gallery', {
		  layoutMode: 'masonry',
		  itemSelector: '.gallery-item',
		  percentPosition: true,
		  masonry: {
		    columnWidth: '.gallery-sizer',
		    gutter: '.gutter-sizer'
		  },
		});

		// UPDATE

		function concatValues( obj ) {
		  var value = '';
		  for ( var prop in obj ) {
		    value += obj[ prop ];
		  }
		  return value;
		}

		const handleButtonClick = (e) => {
			let button = e.target;
			let filterGroup = button.parentElement.parentElement.dataset.group;
			let allButtons = button.parentElement.parentElement.querySelectorAll('li button');

			// UPDATE BUTTON STATE

			allButtons.forEach((button) => {		
				button.classList.remove('active');	
			});
			
			button.classList.add('active');

			// UPDATE FILTERS

			filters[filterGroup] = button.dataset.filter;

			let filterValue = concatValues( filters );

			filterGallery.arrange({ filter: filterValue });

		}

		filterButtons.forEach((button) => {		
			button.addEventListener('click', handleButtonClick);
		});

	});

}